import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SimpleSmoothScrollService } from 'ng2-simple-smooth-scroll';
import { LocationService } from '../../_services/location.service';
import { IMyDpOptions } from 'mydatepicker';
import { ProductRegisterService } from '../../_services/product-register.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-register-product',
  templateUrl: './register-product.component.html',
  styleUrls: ['./register-product.component.scss']
})
export class RegisterProductComponent implements OnInit {
  productObject: any;
  country: string;
  language: string;
  id: number;
  countries: any;
  openModal: boolean;
  open: string;
  empty: string;
  registerCountries: any;

  registerDisable: boolean = true;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };
  registerObj: any = {
    contact: false,
    share: false
  };

  

  public model: any = { date: { year: 2018, month: 10, day: 9 } };
  constructor(
    private locationService: LocationService,
    private route: ActivatedRoute,
    private smooth: SimpleSmoothScrollService,
    private productRegisterService: ProductRegisterService,
    private router: Router

  ) { }

  getLocation(countryParam: string, languageParam: string): void {
    this.locationService.getRegisterCountries(countryParam, languageParam).subscribe(
      response => {
        this.countries = response;
      },
      error => console.log('Error ::' + error)
    );
  }

  // getRegisterCountries(countryParam: string, languageParam: string): void {
  //   this.locationService.getRegisterCountries(countryParam, languageParam).subscribe(
  //     response => {
  //       this.registerCountries = response;
  //     },
  //     error => console.log('Error ::' + error)
  //   );
  // }

  selectCountry(countryId) {
    this.registerObj['retailerCountry'] = countryId
  }

  selectTitle(title) {
    this.registerObj['title'] = title;
  }

  closeEmpty(){
    this.empty = 'none';
  }

  register() {
    console.log(this.registerObj);
    if (this.registerObj.address === undefined || this.registerObj.city === undefined || this.registerObj.dateOfPurchase === undefined ||
      this.registerObj.email === undefined || this.registerObj.firstName === undefined || this.registerObj.lastName === undefined || this.registerObj.postcode === undefined ||
      this.registerObj.retailerCountry === undefined || this.registerObj.title === undefined || this.registerObj.cantact === false || this.registerObj.share === false) {
      this.empty = 'block';

    }
    else {

      this.registerObj.product = this.productObject.product.id;
      this.registerObj.serialNumber = this.productObject.serialNumber;
      this.registerObj.country = this.productObject.country.id;
      this.registerObj.dateOfPurchase =
        this.registerObj.dateOfPurchase.date.year + '-' +
        this.lpad(this.registerObj.dateOfPurchase.date.month, 2, 0) + '-' +
        this.lpad(this.registerObj.dateOfPurchase.date.day, 2, 0);

      this.productRegisterService.registerProduct(this.registerObj,
        this.country, this.language).subscribe(data => {
          this.openModal = false;
          this.open = 'block';
          console.log("success");
        }, error => {

        });

    }
  }

  ngOnInit() {
    setTimeout(() => {
      $(document).foundation();
    }, 2000);

    this.smooth.smoothScrollToAnchor();

    this.productRegisterService.product.subscribe(data => {
      if (data) {
        this.productObject = data;
      }
    });

    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = +params['id'];
          this.country = this.locationService.country;
          this.language = this.locationService.langCode;
          this.getLocation(this.country, this.language);
        }
      );
  }


  goToSupport() {
    this.open = "none";
    setTimeout(() => {
      this.router.navigate(['/', this.country, this.language, 'support']);
    }, 100);
  }

  lpad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}
